import { TypeAsserter } from './type-asserter'
import { TypeChecker } from './type-checker'

export type TypeGuard<T> = TypeChecker<T> | TypeAsserter<T>
export namespace TypeGuard {
  export function isTypeGuard<T>(val: any): val is TypeGuard<T> {
    return TypeChecker.isTypeChecker(val) || TypeAsserter.isTypeAsserter(val)
  }

  export type Function<T> = TypeChecker.Function<T> | TypeAsserter.Function<T>

  export type ExtractTypeFrom<TGuard extends TypeGuard<any>> =
    TGuard extends TypeGuard<infer T> ? T : never

  export interface Props {
    readonly typeDescription: string
  }
}
